import { DestinationAccountControllerType } from "../useDestinationAccount";

import ScrollableContainer from "../../../layout/scrollable-container";
import Container from "../../../layout/container";

import TransitionWrapper from "../../../components/transition-wrapper/TransitionWrapper";

import { FormContainer } from "./styles";
import { TitleLarge } from "../../../components/font";
import { Autocomplete, Button } from "@manifesthhqinc/ui-library";
import Footer from "../../../components/footer";
import { AccountType } from "../../../class/destinationAccount";
import HeadingContainer from "../../../layout/heading-container";

const PlanSponsorName = (props: DestinationAccountControllerType) => {
  const { onClickContinue, currentDestinationDetails, formValidation, updateDestinationDetails, getEmployerOptions } =
    props;

  return (
    <TransitionWrapper>
      <ScrollableContainer name="destination-plan-sponsor">
        <Container>
          <HeadingContainer paneVariant="form" withProgressBar>
            <TitleLarge $textAlign="left">Let’s start with your current employer name</TitleLarge>
          </HeadingContainer>
          <FormContainer>
            <Autocomplete
              name="currentEmployerName"
              title="Current Employer Name"
              size="large"
              value={currentDestinationDetails.planSponsor}
              onChange={(e) =>
                updateDestinationDetails({
                  planSponsor: e?.label || "",
                  destinationAccountType: AccountType.employerSponsored,
                })
              }
              placeholder="Search"
              onLoadOptions={getEmployerOptions}
              errorText={formValidation.planSponsor}
            />
          </FormContainer>
        </Container>
      </ScrollableContainer>
      <Footer>
        <Button onClick={onClickContinue} size="large">
          Continue
        </Button>
      </Footer>
    </TransitionWrapper>
  );
};

export default PlanSponsorName;
